import * as React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const ConstructionIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M15.9038 13.1603L13.7825 15.2816L19.7788 21.2778L21.9001 19.1565L15.9038 13.1603Z" fill="#006E96" />
    <path
      d="M17.4999 10.1097C19.4299 10.1097 20.9999 8.53973 20.9999 6.60973C20.9999 6.02973 20.8399 5.48973 20.5899 5.00973L17.8899 7.70973L16.3999 6.21973L19.0999 3.51973C18.6199 3.26973 18.0799 3.10973 17.4999 3.10973C15.5699 3.10973 13.9999 4.67973 13.9999 6.60973C13.9999 7.01973 14.0799 7.40973 14.2099 7.76973L12.3599 9.61973L10.5799 7.83973L11.2899 7.12973L9.87985 5.71973L11.9999 3.59973C10.8299 2.42973 8.92985 2.42973 7.75985 3.59973L4.21985 7.13973L5.62985 8.54973H2.80985L2.09985 9.25973L5.63985 12.7997L6.34985 12.0897V9.25973L7.75985 10.6697L8.46985 9.95973L10.2499 11.7397L2.83985 19.1497L4.95985 21.2697L16.3399 9.89973C16.6999 10.0297 17.0899 10.1097 17.4999 10.1097Z"
      fill="#006E96"
    />
  </SvgIcon>
);
